import swal from "sweetalert";
import { isMobileApp } from "../global/utils"

if (!isMobileApp) {
  Turbo.config.forms.confirm = (message, element) => {
    const title = element.dataset.turboConfirmTitle || I18n.confirm;
    const dangerMode = element.dataset.turboConfirmDanger !== "false";
    return new Promise((resolve, reject) => {
      swal({
        title: title,
        text: message,
        buttons: true,
        dangerMode: dangerMode,
      }).then((willDelete) => {
        resolve(willDelete);
      });
    });
  };
}
